var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomDnbMinor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 7a7 7 0 11-7-7 7 7 0 017 7zm-7 3a.5.5 0 11-.5.5.5.5 0 01.5-.5zm.5-6.5a.5.5 0 00-1 0v5a.5.5 0 001 0z",
    fill: "#fdbb31",
    fillRule: "evenodd",
    "data-name": "Layer 1"
  }))));
}

export default SvgCustomDnbMinor;